import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, SimpleChanges, OnChanges } from '@angular/core';
import { PrintIngredient } from '../domain/print-ingredient.model';
import { ConfigService } from 'ngx-web-api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fts-print-ingredients',
  templateUrl: './print-ingredients.component.html',
  styleUrls: ['./print-ingredients.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintIngredientsComponent implements OnChanges {
  @Input()
  printableIngredients: PrintIngredient[];
  @Output()
  ingredientNameClick: EventEmitter<string> = new EventEmitter<string>();

  private showHalfNoDefault = false;
  private leftText: string;
  private rightText: string;
  private leftNoText: string;
  private rightNoText: string;

  constructor(public store: ConfigService, private translate: TranslateService) {
    this.store.storeConfig$.subscribe(storeConfig => (this.showHalfNoDefault = storeConfig.showHalfNoDefault));
    this.translate
      .get([
        'component.item_editor.print_ingredients.left_half',
        'component.item_editor.print_ingredients.right_half',
        'component.item_editor.print_ingredients.left_half_no',
        'component.item_editor.print_ingredients.right_half_no',
      ])
      .subscribe(translateObj => {
        this.leftText = translateObj['component.item_editor.print_ingredients.left_half'];
        this.rightText = translateObj['component.item_editor.print_ingredients.right_half'];
        this.leftNoText = translateObj['component.item_editor.print_ingredients.left_half_no'];
        this.rightNoText = translateObj['component.item_editor.print_ingredients.right_half_no'];
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['printableIngredients'] && this.printableIngredients?.length) {
      this.printableIngredients.forEach(pi => {
        const leftSideQuals = [];
        const rightSideQuals = [];
        pi.printText = '';
        if (pi.isLeftHalf) {
          leftSideQuals.push(...(pi.qualifiers || []));
          rightSideQuals.push(...(pi.secondHalfQualifiers || []));
        } else if (pi.isRightHalf) {
          rightSideQuals.push(...(pi.qualifiers || []));
          leftSideQuals.push(...(pi.secondHalfQualifiers || []));
        }
        const invert = !pi.secondHalfQualifiers?.length && pi.isDefault && this.showHalfNoDefault;
        if (pi.isLeftHalf || leftSideQuals?.length) {
          pi.printText = `${invert ? this.rightNoText : this.leftText} ${leftSideQuals.join(' ')} ${pi.name}`;
        }
        if (pi.isRightHalf || rightSideQuals?.length) {
          pi.printText = `${!!pi.printText ? pi.printText.concat(', ') : ''}${
            invert ? this.leftNoText : this.rightText
          } ${rightSideQuals.join(' ')} ${pi.name}`;
        }
        if (!pi.isLeftHalf && !pi.isRightHalf) {
          pi.printText = `${(pi.qualifiers || []).join(' ')} ${pi.name}`;
        }
      });
    }
  }

  identify(index, ingredient) {
    return ingredient.name;
  }
}
